import config from "../config";

const cssVariables = config.cssVariables;

export const applyCssVariables = (
  variables = cssVariables,
  element = document.documentElement
) => {
  Object.entries(variables).forEach(([property, value]) => {
    element.style.setProperty(property, value);
  });
};

export const updateCssVariable = (
  name,
  value,
  element = document.documentElement
) => {
  element.style.setProperty(name, value);
};

export const getCssVariable = (name, element = document.documentElement) => {
  return getComputedStyle(element).getPropertyValue(name);
};
